import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './index.css';
import './styles/layout.css';
import './styles/text.css';
import './styles/wallet-adapter.css';
import './styles/toast.css';
import './styles/form.css';
import 'react-loading-skeleton/dist/skeleton.css';

import { ToastContainer } from 'react-toastify';
import {
   AccountPage,
   AchievementsPage,
   CompeteAndConnectPage,
   ForgotPasswordPage,
   GcoversPage,
   HomePage,
   MembershipsPage,
   MyEntriesPage,
   MyGamePage,
   PageLayout,
   PassportAndMapPage,
   ReferralCenterPage,
   ReferralProgramTos,
   ResetPasswordPage,
   SignupPage,
   SweepstakesPage,
   TermsAndConditions,
} from './pages';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { AppTos } from './pages/AppTos';
import { AppPp } from './pages/AppPp';
import { AppLoyaltyTermsAndConditions } from './pages/AppLoyaltyTermsAndConditions';
import { AppPressYourLuckConditions } from './pages/AppPressYourLuckConditions';
import { SweepstakesTos } from './pages/SweepstakesTos';
import AppleAppSiteAssociation from './pages/AppleAppSiteAssociation';
import { GcoversTos } from './pages/GcoversTos';
import { PaymentSuccessPage } from './pages';
import { ConversionCenter } from './components/convertion-center';

function App() {
   const location = useLocation();

   useEffect(() => {
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
   }, [location]);

   return (
      <>
         <Routes>
            <Route
               path="/"
               element={PageLayout({ page: <HomePage />, hero: { enabled: true } })}
            />
            <Route
               path="/account"
               element={PageLayout({ page: <AccountPage />, hero: { enabled: true, title: 'My Account' } })}
            />

            <Route
               path="/signup"
               // element={<SignupPage />}
               element={PageLayout({ page: <SignupPage />, blank: true })}
            />
            <Route
               path="/referral-center"
               element={PageLayout({ page: <ReferralCenterPage />, hero: { enabled: true, title: 'Referral Center' }, requireAuth: true })}
            />
            <Route
               path="/my-entries"
               element={PageLayout({ page: <MyEntriesPage />, hero: { enabled: true, title: 'My Entries' }, smaller: true, requireAuth: true })}
            />
            <Route
               path="/sweepstakes"
               element={PageLayout({ page: <SweepstakesPage />, hero: { enabled: true, title: 'Sweepstakes' }, left: false, smaller: true })}
            />
            <Route
               path="/achievements"
               element={PageLayout({ page: <AchievementsPage />, hero: { enabled: true, title: 'Achievements' }, comingSoon: true })}
            />
            <Route
               path="/passport-and-map"
               element={PageLayout({ page: <PassportAndMapPage />, hero: { enabled: true, title: 'Passport/Map' }, comingSoon: true })}
            />
            <Route
               path="/compete-and-connect"
               element={PageLayout({ page: <CompeteAndConnectPage />, hero: { enabled: true, title: 'Compete/Connect' }, comingSoon: true })}
            />
            <Route
               path="/memberships"
               element={PageLayout({ page: <MembershipsPage />, hero: { enabled: true, title: 'Memberships' }, comingSoon: true })}
            />
            <Route
               path="/my-game"
               element={PageLayout({ page: <MyGamePage />, hero: { enabled: true, title: 'My Game' }, comingSoon: true })}
            />
            <Route
               path="/reset-password"
               element={PageLayout({ page: <ResetPasswordPage />, hero: { enabled: true, title: 'Password Reset' } })}
            />

            <Route
               path="/forgot-password"
               element={PageLayout({ page: <ForgotPasswordPage />, hero: { enabled: true, title: 'Forgot your Password?' } })}
            />
            {/* <Route
               path="/convert"
               element={PageLayout({ page: <ConversionCenter />, hero: { enabled: true, title: 'Conversion Center' }, requireAuth: true })}
            /> */}

            <Route
               path="/terms-and-conditions"
               element={<TermsAndConditions />}
            />

            <Route
               path="/loyalty-program-terms-and-conditions"
               element={<AppLoyaltyTermsAndConditions />}
            />

            <Route
               path="/app-tos"
               element={<AppTos />}
            />

            <Route
               path="/app-pp"
               element={<AppPp />}
            />

            <Route
               path="/app-press-your-luck-tos"
               element={<AppPressYourLuckConditions />}
            />

            <Route
               path="/sweepstakes-tos"
               element={<SweepstakesTos />}
            />

            <Route
               path="/gcover-tos"
               element={<GcoversTos />}
            />

            <Route
               path="/referral-program-tos"
               element={<ReferralProgramTos />}
            />

            <Route
               path="/.well-known/apple-app-site-association"
               element={<AppleAppSiteAssociation />}
            />

            <Route
               path="/payment/success"
               element={<PaymentSuccessPage />}
            />

            <Route
               path="/g-covers"
               element={PageLayout({ page: <GcoversPage />, hero: { enabled: true, title: 'GolfN G Covers' }, requireAuth: false })}
            />

            <Route
               path="*"
               element={<Navigate to="/" />}
            />
         </Routes>
         <ToastContainer
            position="bottom-left"
            closeOnClick
            theme="dark"
         />
      </>
   );
}

export default App;
